const state = {
    unreadExists: false,
}

const getters = {
    getUnreadExists(state: any) {
        return state.unreadExists;
    }
}

const actions = {
    // incActionCounter(store: any, payload: any){
    //     // Mutationsへ
    //     store.commit('incrementMutateCounter', payload)
    // },
    setUnreadExists(store: any, bool: boolean) {
        return new Promise((resolve) => {
            store.commit('setUnreadExists', bool);
            resolve(true);
        });
    },
    getAndUpdateAllNews(store: any) {
        return new Promise((resolve, reject) => {
            // 既存のお知らせが10以上溜まっていたら消去して最大10件取得
            // 強制受信情報は消さない
            store.dispatch('idbSelectAll', {stateName: null, storeName: 'news'}, { root: true })
            .then(function(data: any) {
                console.log(data.length+'件のニュース!!')
                const overLength = data.length - 10;
                if (overLength > 0) {
                    console.log(overLength+'件の削除します!')
                    for (let i = 0; i < overLength; i++) {
                        if (data[i].require_flg != 1) {
                            store.dispatch('idbDelete', {stateName: null, storeName: 'news', keyValue: data[i].id}, { root: true });
                        }
                    }
                }
                return store.dispatch('idbSelectAll', {stateName: null, storeName: 'news'}, { root: true })
            })
            .then(function(data: any) {
                console.log(data.length+'件!')
                store.dispatch('replaceNewsState', data, { root: true });
                resolve(data);
            })
            .catch(function() {
                reject(false);
            })
        });
    }
}

const mutations = {
    setUnreadExists(state: any, bool: boolean) {
        console.log('commitUnreadExists!!', bool);
        state.unreadExists = bool;
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
